class VliscoFaq {

    constructor() {
        this.options= {
            faqWrapper: '.faq-section-inner',
            faqSidebarItems: '[data-target-section]',
            faqBlockWrapper: '.faq-block-wrapper',
            faqInput: '#faq-search-input',
            faqItem: '.faq-item',
            faqQuestion: '.faq-question',
            faqAnswer: '.faq-answer',
            displayBlock: 'block',
            displayNone: 'hidden',
            navigationItemActiveClass: 'text-black',
            mobileBreakpoint: '(max-width: 767px)',
            searchResultEmptyClass: '.search-result-empty',
            searchResultEmpty: `<div class="search-result-empty text-center py-12 md:py-6 hidden">%content%</div>`
        }

        this.sidebarNavigationItems = document.querySelectorAll(this.options.faqSidebarItems);
        this.faqItems = document.querySelectorAll(this.options.faqItem);
        this.faqSearchInput = document.querySelector(this.options.faqInput);
        this.faqSections = document.querySelectorAll(this.options.faqBlockWrapper);

        this.registerEvents();
    }

    registerEvents() {
        this.addSearchResultEmpty();

        this.faqItems.forEach(item => {
            item.addEventListener('click', () => this.toggleFaqItem(item));
        })

        this.sidebarNavigationItems.forEach(navigationItem => {
            navigationItem.addEventListener('click', () => this.sidebarItemNavigation(navigationItem));
        });

        this.faqSearchInput.addEventListener('keyup', () => this.searchFunction());
    }
    
    toggleFaqItem(item) {
        const answer = item.querySelector(this.options.faqAnswer);

        this[answer.classList.contains(this.options.displayNone) ? 'showItem' : 'hideItem'](answer)
    }

    sidebarItemNavigation(navigationItem) {
        const targetDataAttribute = navigationItem.dataset.targetSection,
            faqItems = document.querySelectorAll('[data-section]');

        this.sidebarNavigationItems.forEach(item => {
            item.classList.remove(this.options.navigationItemActiveClass);
        })

        navigationItem.classList.add(this.options.navigationItemActiveClass);

        faqItems.forEach(item => {
            if (targetDataAttribute == 'all') {
                this.showItem(item);
                return;
            }

            this[item.dataset.section == targetDataAttribute ? 'showItem' : 'hideItem'](item)
        })

        window.matchMedia('(max-width: 767px)').matches
            ? this.scrollToElement('.faq-block-wrapper:not(.hidden)')
            : this.scrollToElement(this.options.faqWrapper);
    }

    searchFunction() {
        const searchedValue = this.faqSearchInput.value.toLowerCase().trim(),
              item = document.querySelectorAll('.faq-item');

        item.forEach(item => {
            const question = item.querySelector('.faq-question'),
                  answer = item.querySelector('.faq-answer'),
                  txtValue = `${question.textContent} ${answer.textContent}`;

            (txtValue.toLowerCase().indexOf(searchedValue) > -1)
            ? item.classList.remove(this.options.displayNone)
            : item.classList.add(this.options.displayNone);
        })

        this.checkSearchedItems();
    }

    checkSearchedItems() {
        const searchResultEmpty = document.querySelector(this.options.searchResultEmptyClass);

        this.faqSections.forEach(section => {
            const faqItems = section.querySelectorAll('.faq-item'),
                    hiddenItems = section.querySelectorAll('.faq-item.hidden');

            faqItems.length == hiddenItems.length
                ? section.classList.add(this.options.displayNone)
                : section.classList.remove(this.options.displayNone);

        });

        const hiddenSections = document.querySelectorAll('.faq-block-wrapper.hidden');

        this.faqSections.length == hiddenSections.length
            ? searchResultEmpty.classList.remove(this.options.displayNone)
            : searchResultEmpty.classList.add(this.options.displayNone);
    }

    showItem(item) {
        item.classList.add(this.options.displayBlock);
        item.classList.remove(this.options.displayNone);
    }

    hideItem(item) {
        item.classList.add(this.options.displayNone);
        item.classList.remove(this.options.displayBlock);
    }

    scrollToElement(selector){
        const headerHeight = document.querySelector('.header')?.offsetHeight || 0,
              element = document.querySelector(selector);

        let navigationMenuHeight = 0;

        if (window.matchMedia(this.options.mobileBreakpoint).matches) {
            const mobileFaqNavigation = document.querySelector('.faq-navigation-mobile');

            navigationMenuHeight = mobileFaqNavigation.classList.contains('sticky')
                ? mobileFaqNavigation.offsetHeight
                : 0;
        }

        window.scrollTo({
            top: element.offsetTop - headerHeight - navigationMenuHeight - 30,
            behavior: 'smooth'
        });
    }
    addSearchResultEmpty() {
        const firstSection = document.querySelector(this.options.faqWrapper),
            searchResultEmpty = this.options.searchResultEmpty.replace('%content%', this.faqSearchInput.dataset.emptyMessage);

        firstSection.insertAdjacentHTML('beforebegin', searchResultEmpty);
    }
}

document.addEventListener('DOMContentLoaded', () => new VliscoFaq());
